import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientMessageListItem } from "@/Patient/Models/History/PatientMessageListItem";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientHistoryMessageHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalPatientOperations.History.Message_LoadPatientMessage, this.LoadPatientMessage);
        this.RegisterOperation(LocalPatientOperations.History.Message_ShowSelectedMessage, this.ShowSelectedMessage);
        this.RegisterOperation(LocalPatientOperations.History.Message_SearchText, this.SearchTextChanged);
        this.RegisterOperation(LocalPatientOperations.History.Message_CriteriaClick, this.CriteriaClick);
        this.RegisterOperation(LocalPatientOperations.History.Message_FromDateChanged, this.FromDateChanged);
        this.RegisterOperation(LocalPatientOperations.History.Message_ToDateChanged, this.ToDateChanged);
        this.RegisterOperation(LocalPatientOperations.History.Message_ToggleListDisplayMode, this.ToggleDisplayMode);
    }

    private LoadPatientMessage(request: LocalEvent, store: PatientStore): void {
        var messageModel = store.PatientHistoryMessagesModels[request.PatientId];

        if (messageModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), messageModel.get("DateFrom"), messageModel.get("DateTo"), messageModel.get("UnreadOnly"));
        else
            store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), null, null, messageModel.get("UnreadOnly"));
    }

    private ShowSelectedMessage(request: LocalEvent, store: PatientStore): void {
        var message = request.Get<PatientMessageListItem>("message");

        var messageModel = store.PatientHistoryMessagesModels[request.PatientId];

        messageModel = messageModel.set("ShowDetails", true);
        messageModel = messageModel.set("SelectedMessageId", message.Model.IndividualMessageId);
        messageModel = messageModel.set("SelectedMessageFrom", message.Model.FromEmployee);
        messageModel = messageModel.set("SelectedMessageBody", message.Model.Body);
        messageModel = messageModel.set("SelectedMessageSubject", message.Model.Subject);

        var toEmployeeArray = message.Model.ToEmployees.split(";");
        var toEmployeeString = "";
        toEmployeeArray.map(employeeId => {
            var employee = cacheStore.GetEmployeeByContactIdOrEmpty(employeeId);
            var employeeTitle = cacheStore.GetLookupById(employee.PrefixLookupId);

            const employeePrefix = !!employeeTitle ? `${employeeTitle.GetValue()} ` : "";

            if (toEmployeeString === "")
                toEmployeeString = employeePrefix + employee.LastName + ", " + employee.FirstName;
            else
                toEmployeeString += " ; " + employeePrefix + employee.LastName + ", " + employee.FirstName;
        });

        messageModel = messageModel.set("SelectedMessageTo", toEmployeeString);

        store.PatientHistoryMessagesModels[request.PatientId] = messageModel;

        store.ActionsHistory.LoadMessageOrTaskNotes(message.Model.IndividualMessageId, SubServerOperations.PatientHistory.LoadMessageNotes);
    }

    private SearchTextChanged(request: LocalEvent, store: PatientStore): void {
        var messageModel = store.PatientHistoryMessagesModels[request.PatientId];
        var searchText = request.Get<string>("value");
        messageModel = messageModel.set("SearchText", searchText);
        store.PatientHistoryMessagesModels[request.PatientId] = messageModel;
        if (messageModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientMessage(request.PatientId, searchText, messageModel.get("DateFrom"), messageModel.get("DateTo"), messageModel.get("UnreadOnly"));
        else
            store.ActionsHistory.LoadPatientMessage(request.PatientId, searchText, null, null, messageModel.get("UnreadOnly"));
    }

    private FromDateChanged(request: LocalEvent, store: PatientStore): void {
        var messageModel = store.PatientHistoryMessagesModels[request.PatientId];
        messageModel = messageModel.set("DateFrom", request.Get<Date>("value"));
        store.PatientHistoryMessagesModels[request.PatientId] = messageModel;
        store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), messageModel.get("DateFrom"), messageModel.get("DateTo"), messageModel.get("UnreadOnly"));
    }

    private ToDateChanged(request: LocalEvent, store: PatientStore): void {
        var messageModel = store.PatientHistoryMessagesModels[request.PatientId];
        messageModel = messageModel.set("DateTo", request.Get<Date>("value"));
        store.PatientHistoryMessagesModels[request.PatientId] = messageModel;
        store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), messageModel.get("DateFrom"), messageModel.get("DateTo"), messageModel.get("UnreadOnly"));
    }

    public CriteriaClick(request: LocalEvent, store: PatientStore): void {
        var messageModel = store.PatientHistoryMessagesModels[request.PatientId];
        var open = messageModel.get("IsCriteriaExpanded");
        messageModel = messageModel.set("IsCriteriaExpanded", !open);
        store.PatientHistoryMessagesModels[request.PatientId] = messageModel;
        if (messageModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), messageModel.get("DateFrom"), messageModel.get("DateTo"), messageModel.get("UnreadOnly"));
        else
            store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), null, null, messageModel.get("UnreadOnly"));
    }

    public ToggleDisplayMode(request: LocalEvent, store: PatientStore): void {
        var messageModel = store.PatientHistoryMessagesModels[request.PatientId];
        messageModel = messageModel.set("UnreadOnly", !messageModel.get("UnreadOnly"));
        store.PatientHistoryMessagesModels[request.PatientId] = messageModel;

        if (messageModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), messageModel.get("DateFrom"), messageModel.get("DateTo"), messageModel.get("UnreadOnly"));
        else
            store.ActionsHistory.LoadPatientMessage(request.PatientId, messageModel.get("SearchText"), null, null, messageModel.get("UnreadOnly"));
    }
}

export { PatientHistoryMessageHandler };
